<script setup lang="ts">
import PgChip from "~/components/Common/PgChip.vue";
import type { Collection } from "~/types";
import type { PropType } from "vue";
import { getCollectionTimestamp, getThumbnailImage } from "~/utils/common";
import useCollectionAiredData from "~/composables/useCollectionAiredData";

const props = defineProps({
  data: {
    type: Object as PropType<Collection>,
    required: true,
  },
});

const { chipInfo } = useCollectionAiredData(props.data);
</script>

<template>
  <NuxtLink
    :to="getCollectionLink({ type: data?.type, slug: data?.label })"
    class="flex flex-shrink-0 gap-3 rounded border border-[#262626] bg-[#141414]/50 p-3 hover:bg-primary-900"
  >
    <div>
      <NuxtImg
        alt="pokergo-logo"
        class="aspect-video w-32 max-w-full rounded object-cover object-center lg:w-40 2xl:w-56"
        :src="
          getThumbnailImage([data?.images || [], data?.pre_air_images || []])
        "
        placeholder="/images/placeholder.png"
        loading="lazy"
      />
    </div>
    <div class="flex flex-col justify-center gap-2">
      <div v-if="chipInfo.label">
        <PgChip
          :icon="chipInfo.icon"
          :label="chipInfo.label"
          :bg="chipInfo.bg"
        />
      </div>
      <div class="text-sm font-semibold">{{ data?.title }}</div>
      <div class="text-xs font-medium text-white/80">
        Started at {{ getCollectionTimestamp(data) }}
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped></style>
